import { render, staticRenderFns } from "./AlarmStatistics.vue?vue&type=template&id=4ba8276b"
import script from "./AlarmStatistics.vue?vue&type=script&lang=js"
export * from "./AlarmStatistics.vue?vue&type=script&lang=js"
import style0 from "./AlarmStatistics.vue?vue&type=style&index=0&id=4ba8276b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports